import React, { useState } from "react";
import { MediaOutlet, MediaPlayer } from "@vidstack/react";

// import JS files

// import others files
import "vidstack/styles/defaults.css";

const VideoPlayer = ({ title, src, poster }) => {
  return (
    <>
      {/* <MediaPlayer title={title} src={src} poster={poster} controls>
        <MediaOutlet />
      </MediaPlayer> */}
      <video poster={poster} width="100%" height="100%" controls>
        <source src={src} type="video/mp4" />
      </video>
    </>
  );
};

export default VideoPlayer;
